exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".setting-fab[data-v-0eccc0f4]{top:50%!important;right:0;border-radius:0}.page-wrapper[data-v-0eccc0f4]{min-height:calc(100vh - 64px - 50px - 81px)}", ""]);

// exports
